<template>
    <div class="order-item" :class="{showImg: showFullImg}" v-if="colorList.length != 0 || installationList.length != 0">
        <div class="front">
            <span v-if="product[0]['number'] != 0" class="order-item__num">{{product[0]['number']}}</span>
            <a :href="getProductUrl" class="order-item__edit-btn"></a>
            <button class="order-item__del-btn" @click.prevent="delFromCart(product[0]['productID'])"></button>
            <div class="order-item__img-block" v-on:click="showFullImg = true">
                <img :src="product[0]['photo']">
            </div>
            <div class="order-item__discription-block">
                <h4 class="order-item__title">{{product[0]['productName']}}</h4>
                
                <div v-if="colorList.length != 0" style="width: 100%;">
                     <div class="order-options" v-for="(offer, index) in colorList" :key="index">
                        <div class="order-options__item" v-if="offer['colorSizeName']">
                            <p class="order-options__title">Размер:</p>
                            <p class="order-options__name">{{offer['colorSizeName']}}</p>
                        </div>
                        <div class="order-options__item" v-if="offer['orientationTitle']">
                            <p class="order-options__title">Ориентация:</p>
                            <p class="order-options__name">{{offer['orientationTitle']}}</p>
                        </div>
                        <div class="order-options__item" v-if="offer['colorName']">
                            <p class="order-options__title">Цвет:</p>
                            <p class="order-options__name">{{offer['colorName']}}</p>
                        </div>
                        <div class="order-options__item">
                            <p class="order-options__title">Количество:</p>
                            <p class="color-item__quantity"> 
                                <span class="minus" @click="minus(offer)">-</span> 
                                    {{offer.quantity}} 
                                <span class="plus" @click="plus(offer)">+</span>
                            </p>
                        </div>
                    </div>
                </div>
               
                <div v-if="installationList.length != 0" style="width: 100%;">
                    <div class="order-item__table-header">
                        <p>Оснаска</p>
                        <p style="margin-right: 5px">Кол-во</p>
                    </div>
                    <div class="order-options" v-for="(offer, index) in installationList" :key="index">
                        <div class="order-options__item">
                            <p class="order-options__title">{{offer.name}}</p>
                            <p class="order-options__name rigging-quantity">{{offer.quantity}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="back" v-bind:style="{ backgroundImage: 'url('+ product[0]['photo'] +')' }" v-on:click="showFullImg = false"></div>
    </div>
</template>
<script>
export default {
    props: ['product', 'serialNumber'],
    data: function(){
        return {
            showFullImg: false,
            productUrl: '',
            colorList: [], //Список заказанных цветов
            installationList: []  //Список заказанных оснасток
        }
    },
    methods: {
        getOptionsLists(){
            this.product.forEach(element => {
                if(element.installationID){
                    this.installationList.push(element)
                }
                if(element.colorID){
                    this.colorList.push(element)
                }
            });
        },
        delFromCart(productID){
            this.$emit('delCartItem', 'productId_'+productID)
        },
        plus(element){
            element.quantity++;
        },
        minus(element){
            if(element.quantity != 0){
                element.quantity--;
            }else{
                element.quantity = 0
            }
        }
    },
    computed: {
        getProductUrl(){
            // url текущего товара
            return this.productUrl = 'catalog/'+this.product[0]['collectionID']+'/'+this.product[0]['productID']
        }
    },
    created(){
        this.getOptionsLists()
    }
}
</script>
<style lang="scss" scoped>
    
    .order-options{
        width: 99%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-bottom: 5px;
        padding-left: 5px;
        box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);
        .order-options__item{
            width: 100%;
            display: flex;
            padding: 5px;
            .order-options__title{
                font-size: 12px;
                line-height: 16px;
                font-weight: 600;
                min-width: 50px;
                margin-right: 5px;
            }
            .color-item__quantity{
                margin-left: auto;
                font-size: 12px;
                line-height: 16px;
                font-weight: 600;
            }
            .order-options__name{
                font-size: 12px;
                line-height: 16px;
            }
        }
    }
    .front{
        width: 100%;
        position: relative;
        display: flex;
        align-items: flex-start;
        padding: 5px;
        transition: 1s;
        backface-visibility: hidden;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
        min-height: 330px;
    }
    .back{
        position: absolute;
        width: 100%;
        height: 100%;
        transition: 1s;
        backface-visibility: hidden;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
        // border: 1px solid #000;
        transform: rotateY(180deg);
        top: 0;
        left: 0;
        img{
            width: 100%;
        }
    }
    .order-item{
        perspective: 1000px;
        width: 330px;
        height: 330px;
        max-width: 100%;
        box-shadow: none;
        .order-item__discription-block{
            overflow: auto;
            max-height: 310px;
        }
        .order-item__discription-block::-webkit-scrollbar {
            width: 0; }

        .order-item__discription-block::-webkit-scrollbar {
            width: 0; }

        .order-item__discription-block::-webkit-scrollbar {
            width: 0; }
    }
    .order-item.showImg .front {transform: rotateY(180deg);}
    .order-item.showImg .back {transform: rotateY(360deg);}
    .rigging-quantity{
        margin-left: auto;
        font-weight: 600;
        min-width: 42px;
        text-align: center;
    }
    .minus,
    .plus{
        display: inline-flex;
        width: 20px;
        height: 20px;
        justify-content: center;
        align-items: center;
        border: 1px solid black;
        &:hover{
            cursor: pointer;
        }
    }
</style>